import React from "react";
import { NavLink } from "react-router-dom";
import "./SidebarItem.css";

type SidebarItemProps = {
  icon: string;
  label: string;
  path?: string | null;
  isExpanded: boolean;
  className?: string;
};

function SidebarItem({
  icon,
  label,
  path,
  isExpanded,
  className,
}: SidebarItemProps) {
  const baseClassName = `sidebar-item ${className || ""}`.trim();

  if (!path) {
    return (
      <div className={baseClassName}>
        <img src={icon} alt={`${label} icon`} className="sidebar-icon" />
        {isExpanded && <span>{label}</span>}
      </div>
    );
  }

  return (
    <NavLink
      to={path}
      className={({ isActive }) =>
        `${baseClassName} ${isActive ? "active" : ""}`.trim()
      }
    >
      <img src={icon} alt={`${label} icon`} className="sidebar-icon" />
      {isExpanded && <span>{label}</span>}
    </NavLink>
  );
}

export default SidebarItem;
